















































import {Vue, Component, Watch} from 'vue-property-decorator'
import {NormativPotrosnjeGoriva, Vozilo} from "@/services/BackendProxies";
import dataProxy from '@/services/data-proxy.service';
import Tab1 from './Tab1.vue';
import Tab2 from './Tab2.vue';
import Tab3 from './Tab3.vue';
import Tab4 from './Tab4.vue';
import Tab5 from './Tab5.vue';
import {Mutation, State} from "vuex-class";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({components: {Tab1, Tab2, Tab3, Tab4, Tab5}})
export default class PodaciVozila extends mixins(ComponentBaseMixin) {
    @State vozilo: Vozilo;
    @Mutation setVozilo;
    currentTab = 0;

    async created() {
        this.load();
    }

    @Watch('$route') onRouteChanged() {
        this.load();
    }

    async load() {
        const id = +this.$route.params.id;
        if (id) {
            const vozilo = await this.loadData<Vozilo>(() => dataProxy.vratiVozilo(id))();
            setTimeout(() => this.setVozilo(vozilo), 1000);
            this.currentTab = 0;
        } else {
            this.setVozilo(new Vozilo());
        }
    }
}
